import { api_GET_Unauthorize } from "api/axios.js";

const prefeitura_api =
{
    getLogotipo: function(){        
        const promise = new Promise((resolve, reject) => { 
            api_GET_Unauthorize(`prefeitura/GetLogotipo`).then(result => {
                if (result.status == 200)
                    resolve(result.data)
                else    
                    resolve("");
            });
        });
        return promise;
    }
}

export default prefeitura_api
